import { Injectable } from '@angular/core';
import { CardGameService, CardsGameConfig, storageKey } from '@memory/services/card-game.service';

export interface Info {
  prefix: GameName
}

export const GameNames = [
  'memoryCards',
  'findNumber',
  'fifteen',
  'mascot',
  'quiz',
  'meditation',
  'waves',
  'hole',
  'particles',
  'tension',
  'main'] as const;

export type GameName = typeof GameNames[number];

@Injectable({
  providedIn: 'root'
})
export class LobbyService {

  constructor(private gameService: CardGameService) {
  }

  loadConfig(key?: string): CardsGameConfig {
    return this.gameService.loadConfig(key)
  }

  saveConfig(config: CardsGameConfig) {
    localStorage.setItem(storageKey, JSON.stringify(config))
  }
}
